import { render } from "./Import.vue?vue&type=template&id=7d4635c4"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\WORKZONE\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__